import React, { useState, useEffect } from 'react';
import {
    Box, Paper, TextField, Typography, Tabs, Tab, Autocomplete,
    RadioGroup, FormControlLabel, Radio, Button, Checkbox, CircularProgress
} from '@mui/material'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { ImagePaths } from '../../../Utility/ImagePaths';
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import { Colors } from '../../../Styles/Colors';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';

const formatList = [
    { label: "A4 Portrait", value: "portrait_a4" },
    // { label: "A4 Landscape", value: "landscape_a4" },
    // { label: "A5 Portrait", value: "portrait_a5" },
    // { label: "A5 Landscape", value: "landscape_a5" }
]

const fontList = [
    { label: "Arial", value: "Arial" },
    { label: "Times New Roman", value: "TimesNewRoman" },
    { label: "Calibri", value: "Calibri" },
    { label: "Verdana", value: "Verdana" },
    { label: "Helvetica", value: "Helvetica" }
]

const fontSizeList = [8, 9, 10, 11, 12];

const viewSpecimenList = [
    { label: "Combined", value: "combined" },
    { label: "Separated", value: "separated" },
]

const additionalConfigList = [
    { label: "Show Group Name For Individual Test", key: "show_group_name_for_individual_test" },
    { label: "Show Lab Result print patient details in lateral page", key: "patient_details_in_lateral_pages" },
    { label: "View Specimen Row", key: "view_specimen_row", key2: "view_specimen_row_as", list: viewSpecimenList },
    { label: "Show Overall Sample Collected Date on print", key: "show_overall_sample_collected_date" },
    { label: "Show Prepared By on print", key: "show_report_prepared_by" },
]

const placementList = [
    { label: "Left", value: "left" },
    { label: "Right", value: "right" }]

const alignmentList = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" }
]

const gridSetupList = [
    { label: "Vertical", value: "vertical", icon: ImagePaths.verticalIcon.default },
    { label: "Horizontal", value: "horizontal", icon: ImagePaths.horizontalIcon.default },
    { label: "Both", value: "both", icon: ImagePaths.bothIcon.default },
    { label: "Outline", value: "outline", icon: ImagePaths.outlineIcon.default },
    { label: "None", value: "none", icon: "" }
]

const contentPatient = [
    { id: 1, field_name: "name", system_name: "Name", custom_name: "Name", placement: "left", is_active: true, is_separate_age: true },
    { id: 2, field_name: "age_gender", system_name: "Age/Gender", custom_name: "Age/Gender", placement: "left", is_active: true },
    { id: 3, field_name: "uhid", system_name: "UHID", custom_name: "UHID", placement: "left", is_active: true },
    { id: 4, field_name: "mobile_no", system_name: "Mobile No", custom_name: "Mobile No", placement: "left", is_active: true },
    { id: 5, field_name: "address", system_name: "Address", custom_name: "Address", placement: "left", is_active: true },
    { id: 6, field_name: "consultant_name", system_name: "Consultant Name", custom_name: "Consultant Name", placement: "left", is_active: true },
    { id: 7, field_name: "referred_doctor", system_name: "Referred Doctor", custom_name: "Referred Doctor", placement: "left", is_active: true },
    { id: 8, field_name: "barcode", system_name: "Barcode", custom_name: "Barcode", placement: "right", is_active: true },
    { id: 9, field_name: "bill_no", system_name: "Bill No", custom_name: "Bill No", placement: "right", is_active: true },
    { id: 10, field_name: "bill_date", system_name: "Bill Date", custom_name: "Bill Date", placement: "right", is_active: true },
    { id: 11, field_name: "report_completed_date", system_name: "Report Completed Date", custom_name: "Report Completed Date", placement: "right", is_active: true },
]

const contentTestReport = [
    { id: 1, field_name: "test_report", system_name: "Test Report", custom_name: "Test Report", alignment: "left", is_active: true },
    { id: 2, field_name: "specimen_column", system_name: "Specimen (If Column)", custom_name: "Specimen", alignment: "left", is_active: true, width: 20 },
    { id: 3, field_name: "test_name", system_name: "Test Name", custom_name: "Test Name", alignment: "left", is_active: true, width: 20 },
    { id: 4, field_name: "result", system_name: "Result", custom_name: "Result", alignment: "left", is_active: true, width: 20 },
    { id: 5, field_name: "units", system_name: "Units", custom_name: "Units", alignment: "left", is_active: true, width: 20 },
    { id: 6, field_name: "reference_range", system_name: "Reference Range", custom_name: "Reference Range", alignment: "left", is_active: true, width: 20 },
    { id: 7, field_name: "sample_collected_date", system_name: "Sample Collected Date", custom_name: "Sample Collected Date", alignment: "left", is_active: true },
    { id: 8, field_name: "specimen_row", system_name: "Specimen (If Row)", custom_name: "Specimen", alignment: "left", is_active: false },
    { id: 9, field_name: "department_name", system_name: "Department Name", custom_name: "Department Name", alignment: "left", is_active: true },
    { id: 10, field_name: "group_name", system_name: "Group Name", custom_name: "Group Name", alignment: "left", is_active: true },
    // { id: 10, field_name: "test_names", system_name: "Test Name", custom_name: "Test Name", alignment: "left", is_active: true },
]

const endOfReport = [
    { id: 1, field_name: "end_of_report", system_name: "End Of The Report", custom_name: "End Of The Report", alignment: "left", space_between_table: "0.5", is_active: true }
]

const maxCount4 = new Set(["Margintop", "MarginRight", "MarginBottom", "MarginLeft", "gridLine", "separationLine"])
const disableFields = new Set(["specimen_row", "department_name", "group_name", "test_names"])
const keysHavingWidth = new Set(["specimen_column", "test_name", "result", "units", "reference_range"]);
const disableContentFields = new Set(["bill_no", "bill_date", "barcode", "uhid"]) 

const LabPrintConfiguration = (props) => {
    const [state, setState] = useState({
        previewUrl: "",
        previewLoader: false,
        tabValue: 'basic',
        basicData: {
            format: "portrait_a4",
            font: "Helvetica",
            fontSize: 10,
            Margintop: "0.5",
            MarginRight: "0.5",
            MarginBottom: "0.5",
            MarginLeft: "0.5",
            gridSetup: "vertical",
            gridLine: "0.1",
            separationLine: "0.1",
            withOutHeader: "",
            woHeadSpace: "",
            withOutFooter: "",
            woFootSpace: "",
            withHeader: "withHeader",
            printHeaderAllpages: true,
            withFooter: "withFooter",
            printFooterAllpages: true,
        },
        validationBasicError: {
            Margintop: "",
            MarginRight: "",
            MarginBottom: "",
            MarginLeft: "",
            gridLine: "",
            separationLine: "",
            woHeadSpace: "",
            woFootSpace: "",
        },
        content_patient: JSON.parse(JSON.stringify(contentPatient)),
        content_test_report: JSON.parse(JSON.stringify(contentTestReport)),
        end_of_the_report: JSON.parse(JSON.stringify(endOfReport)),
        pathology: {
            left: "Lab Incharge",
            center: "Lab Technician",
            right: "Clinical Pathologist",
            is_active: true
        },
        microBiology: {
            left: "Lab Incharge",
            center: "Lab Technician",
            right: "Microbiologist",
            is_active: true
        },
        show_group_name_for_individual_test: true,
        patient_details_in_lateral_pages: true,
        view_specimen_row: false,
        view_specimen_row_as: "combined",
        show_overall_sample_collected_date: true,
        show_report_prepared_by: true,
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
        isLoader: false,
    })

    useEffect(() => {
        getLayoutData()
        getPreviewUrl()
    }, [])

    const updateState = (newState) => {
        setState((prevState) => ({
            ...prevState,
            ...newState
        }))
    }

    const findValue = (list = [], value) => {
        return list?.find(item => item.value === value) || null;
    }

    const toValidStr = (val, fallback = "0.5") => {
        return val != null ? String(val) : fallback;
    };

    const getLayoutData = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        try {
            RestAPIService.getAll(Serviceurls.LAB_REPORT_PRINT_CONFIG + `?lab_id=${loginInfo?.laboratory_id || ''}&clinic_id=${loginInfo?.clinic_id || ''}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data;
                        const reportEnd = Data?.content_setup?.page_end?.end_of_the_report || {};
                        const endReport = {
                            ...reportEnd,
                            space_between_table: toValidStr(reportEnd.space_between_table, "0.5")
                        };
                        updateState({
                            basicData: {
                                format: Data?.basic_layout?.format || "portrait_a4",
                                font: Data?.basic_layout?.font || "Helvetica",
                                fontSize: Data?.basic_layout?.font_size || 10,
                                Margintop: toValidStr(Data?.basic_layout?.margin_top),
                                MarginRight: toValidStr(Data?.basic_layout?.margin_right),
                                MarginBottom: toValidStr(Data?.basic_layout?.margin_bottom),
                                MarginLeft: toValidStr(Data?.basic_layout?.margin_left),
                                gridSetup: Data?.basic_layout?.grid_setup || "vertical",
                                gridLine: toValidStr(Data?.basic_layout?.grid_line, "0.1"),
                                separationLine: toValidStr(Data?.basic_layout?.separation_line, "0.1"),
                                withOutHeader: Data?.basic_layout?.with_out_header || "",
                                woHeadSpace: toValidStr(Data?.basic_layout?.header_space, ""),
                                withOutFooter: Data?.basic_layout?.with_out_footer || "",
                                woFootSpace: toValidStr(Data?.basic_layout?.footer_space, ""),
                                withHeader: Data?.basic_layout?.with_header,
                                printHeaderAllpages: Data?.basic_layout?.print_header_allpages,
                                withFooter: Data?.basic_layout?.with_footer,
                                printFooterAllpages: Data?.basic_layout?.print_footer_allpages,
                            },
                            content_patient: JSON.parse(JSON.stringify(Data?.content_setup?.patient_details || contentPatient)),
                            content_test_report: JSON.parse(JSON.stringify(Data?.content_setup?.test_report || contentTestReport)),
                            end_of_the_report: [endReport] || JSON.parse(JSON.stringify(endOfReport)),
                            pathology: Data?.content_setup?.page_end?.pathology || ({
                                left: "Lab Incharge",
                                center: "Lab Technician",
                                right: "Clinical Pathologist",
                                is_active: true
                            }),
                            microBiology: Data?.content_setup?.page_end?.microbiology || ({
                                left: "Lab Incharge",
                                center: "Lab Technician",
                                right: "Microbiologist",
                                is_active: true
                            }),
                            show_group_name_for_individual_test: Data?.additional_config?.show_group_name_for_individual_test || false,
                            patient_details_in_lateral_pages: Data?.additional_config?.patient_details_in_lateral_pages || false,
                            view_specimen_row: Data?.additional_config?.view_specimen_row || false,
                            view_specimen_row_as: Data?.additional_config?.view_specimen_row_as || "combined",
                            show_overall_sample_collected_date: Data?.additional_config?.show_overall_sample_collected_date || false,
                            show_report_prepared_by: Data?.additional_config?.show_report_prepared_by || false,
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPreviewUrl = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        try {
            updateState({ previewUrl: "", previewLoader: true })
            RestAPIService.GetWithoutReplica(`${Serviceurls.LAB_REPORT_PRINT_CONFIG_PREVIEW}?lab_id=${loginInfo?.laboratory_id || ''}&clinic_id=${loginInfo?.clinic_id || ''}&preview=true`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    updateState({
                        previewUrl: fileURL,
                        previewLoader: false
                    })
                }).catch((e) => {
                    updateState({ previewLoader: false })
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            updateState({ previewLoader: false })
            errorMessage(e?.response?.data?.message || e.message)
        }
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }
    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const resetPrintDetails = () => {
        updateState({
            basicData: {
                format: "portrait_a4",
                font: "Helvetica",
                fontSize: 10,
                Margintop: "0.5",
                MarginRight: "0.5",
                MarginBottom: "0.5",
                MarginLeft: "0.5",
                gridSetup: "vertical",
                gridLine: "0.1",
                separationLine: "0.1",
                withOutHeader: "",
                woHeadSpace: "",
                withOutFooter: "",
                woFootSpace: "",
                withHeader: "withHeader",
                printHeaderAllpages: true,
                withFooter: "withFooter",
                printFooterAllpages: true,
            },
            validationBasicError: {
                Margintop: "",
                MarginRight: "",
                MarginBottom: "",
                MarginLeft: "",
                gridLine: "",
                separationLine: "",
            },
            content_patient: JSON.parse(JSON.stringify(contentPatient)),
            content_test_report: JSON.parse(JSON.stringify(contentTestReport)),
            end_of_the_report: JSON.parse(JSON.stringify(endOfReport)),
            pathology: {
                left: "Lab Incharge",
                center: "Lab Technician",
                right: "Clinical Pathologist",
                is_active: true
            },
            microBiology: {
                left: "Lab Incharge",
                center: "Lab Technician",
                right: "Microbiologist",
                is_active: true
            },
            show_group_name_for_individual_test: true,
            patient_details_in_lateral_pages: true,
            view_specimen_row: false,
            view_specimen_row_as: "combined",
            show_overall_sample_collected_date: true,
            show_report_prepared_by: true,
            isLoader: false,
        })
    }

    const validateItem = () => {
        const { basicData } = state;

        const format = basicData.format || "";
        const isPortraitA4 = format === "portrait_a4";
        const isPortraitA5 = format === "portrait_a5";
        const isLandscape = format?.includes("landscape");

        const left = parseFloat(basicData.MarginLeft) || 0;
        const right = parseFloat(basicData.MarginRight) || 0;
        const top = parseFloat(basicData.Margintop) || 0;
        const bottom = parseFloat(basicData.MarginBottom) || 0;

        const errors = {};
        let firstError = "";

        let leftRightSumValid = true;
        let topBottomSumValid = true;

        // Step 1: Check sum limits
        if (isPortraitA4 && (left + right) > 4) {
            const msg = "Sum of Left and Right margins should not exceed 4cm.";
            errors.MarginLeft = msg;
            errors.MarginRight = msg;
            leftRightSumValid = false;
            if (!firstError) firstError = msg;
        }

        if (isPortraitA5) {
            if ((left + right) > 2) {
                const msg = "Sum of Left and Right margins should not exceed 2cm.";
                errors.MarginLeft = msg;
                errors.MarginRight = msg;
                leftRightSumValid = false;
                if (!firstError) firstError = msg;
            }
            if ((top + bottom) > 2) {
                const msg = "Sum of Top and Bottom margins should not exceed 2cm.";
                errors.Margintop = msg;
                errors.MarginBottom = msg;
                topBottomSumValid = false;
                if (!firstError) firstError = msg;
            }
        }

        if (isLandscape && (top + bottom) > 4) {
            const msg = "Sum of Top and Bottom margins should not exceed 4cm.";
            errors.Margintop = msg;
            errors.MarginBottom = msg;
            topBottomSumValid = false;
            if (!firstError) firstError = msg;
        }

        // Step 2: Required fields only if sum is invalid or sum is 0
        const fields = [
            { key: "Margintop", label: "Margin Top", skipIfSumValid: top + bottom > 0 && topBottomSumValid },
            { key: "MarginRight", label: "Margin Right", skipIfSumValid: left + right > 0 && leftRightSumValid },
            { key: "MarginBottom", label: "Margin Bottom", skipIfSumValid: top + bottom > 0 && topBottomSumValid },
            { key: "MarginLeft", label: "Margin Left", skipIfSumValid: left + right > 0 && leftRightSumValid },
            { key: "gridLine", label: "Grid Line" },
            { key: "separationLine", label: "Separation Line" },
            { key: "woHeadSpace", label: "Header Spacing", condition: basicData.withOutHeader },
            { key: "woFootSpace", label: "Footer Spacing", condition: basicData.withOutFooter },
        ];

        for (const { key, label, condition = true, skipIfSumValid = false } of fields) {
            const value = basicData?.[key];

            if (condition && value === "" && !skipIfSumValid) {
                const message = `${label} is required.`;
                errors[key] = message;
                if (!firstError) firstError = message;
            } else {
                if (!errors[key]) errors[key] = "";
            }
        }

        // Step 3: Update validation state
        updateState({
            validationBasicError: {
                ...state.validationBasicError,
                ...errors,
            },
        });

        // Step 4: Return true if no errors
        return Object.values(errors).every(msg => !msg);
    };


    const validateWidth = (list) => {
        let totalWidth = 0;

        for (const item of list) {
            if (item.is_active && keysHavingWidth.has(item.field_name)) {
                const width = +item.width || 0;
                totalWidth += width;
                if (width < 20) {
                    return `${item.system_name} width should not be less than 20%`;
                }
            }
        }

        if (totalWidth > 100) {
            return "Total width of active fields should not exceed 100%";
        }
        if (totalWidth < 100) {
            return "Total width of active fields should not be less than 100%";
        }
        return ""; // No error
    };

    const validateData = (label, content) => {
        // Check if any custom_name is empty
        const missingCustomName = content.some(item => !item.custom_name?.trim());
        if (missingCustomName) {
            return `${label} Custom name is required for all fields.`;
        }

        // Check if all is_active are false
        const activeFields = content?.filter(item => item.is_active);
        if (activeFields?.length === 0) {
            return `${label} Atleast one field must be active.`;
        }

        // For Patient details, check alignment or not on same side
        if (label === "Patient details") {
            const uniquePlacements = new Set(activeFields.map(field => field.placement));
            if (uniquePlacements.size === 1) {
                return "All active fields are aligned to the same side. Please distribute them between left and right";
            }
        }

        // For Test Report, check width only if above are valid
        if (label === "Test Report") {
            const widthError = validateWidth(content);
            if (widthError) return widthError;
        }

        return "";
    };

    const validateEndOfReport = (label, obj) => {
        let message = "";

        if (!obj?.custom_name?.toString().trim()) {
            message = `${label} Custom Name is required.`;
        } else if (
            obj.space_between_table === undefined ||
            obj.space_between_table === null ||
            obj.space_between_table.toString().trim() === ""
        ) {
            message = `${label} Spacing Between Table is required.`;
        }

        return message;
    };

    const validateObj = (label, Obj) => {

        const left = Obj.left?.trim();
        const center = Obj.center?.trim();
        const right = Obj.right?.trim();

        if (!left && !center && !right) {
            return `${label} at least one value is required.`;
        }

        return "";
    };

    const validationData = () => {
        updateState({ isLoader: true });
        const validMsg = validateItem() ? "" : "Please fill all the required fields in Basic Layout";
        const validPatientMsg = validateData("Patient details", state.content_patient);
        const validtestMsg = validateData("Test Report", state.content_test_report);
        const validEndRptMsg = validateEndOfReport("End of the Report", state.end_of_the_report[0]);
        const validPathologyMsg = validateObj("Pathology ", state.pathology);
        const validMicrobiologyMsg = validateObj("Microbiology ", state.microBiology);
        const validateSampleDate = (state.show_overall_sample_collected_date && state.content_test_report[6]?.alignment === "center") ?
            "Overall Sample Collected Date in Content Layout cannot be center aligned" : ""

        const errorMsg = validMsg || validPatientMsg || validtestMsg || validEndRptMsg || validPathologyMsg || validMicrobiologyMsg || validateSampleDate;
        if (errorMsg === "") {
            postPrintDetails();
        } else {
            updateState({
                isLoader: false,
                isErrorMsg: true,
                isErrorMsgText: errorMsg
            });
        }
    }

    const toValidNumber = (val, fallback = 0.5) => {
        const num = parseFloat(val);
        return isNaN(num) ? fallback : num;
    };

    const postPrintDetails = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        const item = state.end_of_the_report[0] || endOfReport[0];

        const updatedEndRpt = {
            ...item,
            space_between_table: toValidNumber(item.space_between_table, 0),
        };

        try {
            const data = {
                lab_id: loginInfo?.laboratory_id || null,
                clinic_id: loginInfo?.clinic_id || null,
                basic_layout: {
                    format: state.basicData.format || "portrait_a4",
                    font: state.basicData.font || "Helvetica",
                    font_size: state.basicData.fontSize || 10,
                    margin_top: toValidNumber(state.basicData.Margintop),
                    margin_right: toValidNumber(state.basicData.MarginRight),
                    margin_bottom: toValidNumber(state.basicData.MarginBottom),
                    margin_left: toValidNumber(state.basicData.MarginLeft),
                    grid_setup: state.basicData.gridSetup || "vertical",
                    grid_line: toValidNumber(state.basicData.gridLine, 0.1),
                    separation_line: toValidNumber(state.basicData.separationLine, 0.1),
                    with_out_header: state.basicData.withOutHeader || "",
                    header_space: toValidNumber(state.basicData.woHeadSpace, 0),
                    with_out_footer: state.basicData.withOutFooter || "",
                    footer_space: toValidNumber(state.basicData.woFootSpace, 0),
                    with_header: state.basicData.withHeader || "",
                    print_header_allpages: state.basicData.printHeaderAllpages,
                    with_footer: state.basicData.withFooter || "",
                    print_footer_allpages: state.basicData.printFooterAllpages,
                },
                content_setup: {
                    patient_details: state.content_patient,
                    test_report: state.content_test_report,
                    page_end: {
                        end_of_the_report: updatedEndRpt,
                        pathology: state.pathology,
                        microbiology: state.microBiology,
                    },
                },
                additional_config: {
                    show_group_name_for_individual_test: state.show_group_name_for_individual_test || false,
                    patient_details_in_lateral_pages: state.patient_details_in_lateral_pages || false,
                    view_specimen_row: state.view_specimen_row || false,
                    view_specimen_row_as: state.view_specimen_row_as || "combined",
                    show_overall_sample_collected_date: state.show_overall_sample_collected_date || false,
                    show_report_prepared_by: state.show_report_prepared_by || false,
                },
            }

            RestAPIService.create(data, Serviceurls.LAB_REPORT_PRINT_CONFIG)
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        updateState({ isLoader: false });
                        getLayoutData();
                        getPreviewUrl();
                    }
                }).catch((error) => {
                    errorMessage(error.response.data.message || error.message)
                    updateState({ isLoader: false });
                })
        }
        catch (e) {
            errorMessage(e.message)
            updateState({ isLoader: false });
        }
    }

    const handleBasicDataChange = (key, value) => {
        const num = parseFloat(value);
        let errorMessage = "";
        switch (key) {
            case "gridLine":
            case "separationLine":
                if (value === "") {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value
                        },
                        validationBasicError: {
                            ...state.validationBasicError,
                            [key]: ""
                        }
                    });
                    break;
                } else if (!isNaN(num) && num >= 0 && num <= 1.5) {
                    if (num < 0.1) {
                        errorMessage = "Value should be greater than or equal to 0.1";
                    }
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value
                        },
                        validationBasicError: {
                            ...state.validationBasicError,
                            [key]: errorMessage
                        }
                    });
                }
                break;
            case "format":
                const obj = {
                    Margintop: "",
                    MarginRight: "",
                    MarginBottom: "",
                    MarginLeft: "",
                }
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        ...obj,
                    },
                    validationBasicError: {
                        ...state.validationBasicError,
                        ...obj,
                    }
                });
                break;
            case "Margintop":
            case "MarginRight":
            case "MarginBottom":
            case "MarginLeft":
                const valNum = CommonValidation.DecimalNumberOne(value);
                if (value === "") {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value
                        },
                        validationBasicError: {
                            ...state.validationBasicError,
                            [key]: ""
                        }
                    });
                    break;
                } else if (valNum && num >= 0 && num <= 4) {
                    let updatedBasicData = { ...state.basicData, [key]: value };
                    const isLandscape = updatedBasicData.format?.includes("landscape");

                    // Clear all margin errors initially
                    let validationErrors = {
                        ...state.validationBasicError,
                        MarginLeft: "",
                        MarginRight: "",
                        Margintop: "",
                        MarginBottom: ""
                    };

                    const left = parseFloat(updatedBasicData.MarginLeft) || 0;
                    const right = parseFloat(updatedBasicData.MarginRight) || 0;
                    const top = parseFloat(updatedBasicData.Margintop) || 0;
                    const bottom = parseFloat(updatedBasicData.MarginBottom) || 0;

                    // Margin sum validation
                    if (updatedBasicData.format === "portrait_a4" && (key === "MarginRight" || key === "MarginLeft")) {
                        if ((left + right) > 4) {
                            const msg = "Sum of Left and Right margins should not exceed 4cm";
                            if (left) validationErrors.MarginLeft = msg;
                            if (right) validationErrors.MarginRight = msg;
                        }
                    }
                    if (updatedBasicData.format === "portrait_a5" && (key === "MarginRight" || key === "MarginLeft" || key === "Margintop" || key === "MarginBottom")) {
                        if ((left + right) > 2) {
                            const msg = "Sum of Left and Right margins should not exceed 2cm";
                            if (left) validationErrors.MarginLeft = msg;
                            if (right) validationErrors.MarginRight = msg;
                        }
                        if ((top + bottom) > 2) {
                            const msg = "Sum of Top and Bottom margins should not exceed 2cm";
                            if (top) validationErrors.Margintop = msg;
                            if (bottom) validationErrors.MarginBottom = msg;
                        }
                    }
                    if (isLandscape && (key === "Margintop" || key === "MarginBottom")) {
                        if ((top + bottom) > 4) {
                            const msg = "Sum of Top and Bottom margins should not exceed 4cm";
                            if (top) validationErrors.Margintop = msg;
                            if (bottom) validationErrors.MarginBottom = msg;
                        }
                    }

                    // Only set minimum value error if there's no sum error
                    if (!validationErrors[key] && num < 0.5 && num !== 0) {
                        validationErrors[key] = "Value should be greater than or equal to 0.5";
                    }
                    updateState({
                        basicData: updatedBasicData,
                        validationBasicError: validationErrors
                    });
                }
                break;
            case "withOutHeader":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        withHeader: "",
                        printHeaderAllpages: false,
                    }
                });
                break;
            case "withHeader":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        printHeaderAllpages: true,
                        withOutHeader: "",
                        woHeadSpace: "",
                    }
                });
                break;
            case "withOutFooter":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        withFooter: "",
                        printFooterAllpages: false,
                    }
                });
                break;
            case "withFooter":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        printFooterAllpages: true,
                        withOutFooter: "",
                        woFootSpace: "",
                    }
                });
                break;
            case "woHeadSpace":
                const val = CommonValidation.DecimalNumberOne(value)
                if (value === '' || (val && num >= 0 && num <= 2)) {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value,
                        }
                    })
                }
                break;
            case "woFootSpace":
                const numVal = CommonValidation.DecimalNumberOne(value)
                if (value === '' || (numVal && num >= 0 && num <= 2)) {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value,
                        }
                    })
                }
                break;
            default:
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                    }
                });
                break;
        }
    };

    const handleContentChange = (sectionKey, key, updateKey, value) => {
        const updatedContent = state?.[sectionKey]?.map((item) => {
            // Update the item that matches the key
            if (item.field_name === key) {
                if (updateKey === "space_between_table") {
                    const val = CommonValidation.DecimalNumberOne(value);
                    if ((val && +value >= 0 && +value <= 2) || value === '') {
                        return { ...item, [updateKey]: value };
                    }
                    return item;
                } else if (updateKey === "is_active") {
                    const shouldClearWidth = !value && keysHavingWidth.has(item.field_name);
                    return {
                        ...item,
                        is_active: value,
                        ...(shouldClearWidth && { width: 0 })
                    };
                } else if (updateKey === "width") {
                    const val = CommonValidation.numberOnly(value);
                    if ((val && +value >= 0 && +value <= 100) || value === '') {
                        return { ...item, [updateKey]: +value };
                    }
                    return item;
                }

                return { ...item, [updateKey]: value };
            }

            // Handle age_gender vs name toggle
            if (sectionKey === "content_patient" && ((updateKey === "is_separate_age" && item.field_name === "age_gender") ||
                (updateKey === "is_active" && item.field_name === "name"))) {
                return { ...item, [updateKey === "is_active" ? "is_separate_age" : "is_active"]: value };
            }
            if (sectionKey === "content_test_report" && ((updateKey === "specimen_column" && item.field_name === "specimen_row") ||
                (updateKey === "specimen_row" && item.specimen_column === "name"))) {
                return { ...item, ["is_active"]: false };
            }

            return item;
        });

        updateState({ [sectionKey]: updatedContent });
    };

    const renderAutoComplete = (label, statekey, value, list = [], showKey, handleChange, isDisable = false, width) => {
        return (
            <Box>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{label}</Typography>}
                <Autocomplete
                    size="small"
                    options={list || []}
                    getOptionLabel={(option) => (typeof option === "string" ? option : option?.[showKey] ? option[showKey] || "" : JSON.stringify(option))}
                    value={statekey === "fontSize" ? value : findValue(list, value) || null}
                    disabled={isDisable}
                    disableClearable
                    onChange={(event, newValue) => { handleChange(statekey, newValue) }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ width: width ? width : "100%" }}
                            size='small'
                            label={label}
                            autoComplete="off"
                            inputProps={{
                                ...params.inputProps,
                                emed_tid: `lab_print_config_${statekey}_autocomplete`
                            }}
                        />
                    )}
                />
            </Box>
        );
    };

    const renderTextField = (label = "", name, value, showHelper = false, handleChange) => {
        return (
            <Box sx={{ width: handleChange ? "100%" : "40%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} flex={0.4}>{label}</Typography>}
                <TextField
                    size='small'
                    sx={{ flex: (handleChange || label === "") ? 1 : 0.6 }}
                    autoComplete='off'
                    disabled={
                        (name === "woHeadSpace" && !state.basicData?.withOutHeader) ||
                            (name === "woFootSpace" && !state.basicData?.withOutFooter)
                            ? true
                            : false
                    }
                    value={value}
                    inputProps={{ maxLength: maxCount4.has(name) ? 4 : 25 }}
                    onChange={(e) => { (handleChange || handleBasicDataChange)(name, e.target.value) }}
                    InputProps={{
                        endAdornment: <Typography>{handleChange ? "" : showHelper ? "px" : "cm"}</Typography>,
                        emed_tid: `Field_${name}`
                    }}
                    helperText={
                        (["gridLine", "separationLine"]?.includes(name) && !state.validationBasicError[name])
                            ? "0.1px - 1.5px"
                            : state.validationBasicError[name] || ""
                    }
                    error={Boolean(state.validationBasicError[name])}
                />
            </Box>
        )
    }

    const renderContentTextField = (sectionKey, field_name, stateKey, idx, isDisable = false) => {
        return (
            <TextField
                size='small'
                fullWidth
                disabled={disableFields.has(field_name) || isDisable}
                autoComplete='off'
                value={state[sectionKey][idx][stateKey] || ""}
                inputProps={{ maxLength: stateKey === "space_between_table" ? undefined : 25 }}
                onChange={(e) => { handleContentChange(sectionKey, field_name, stateKey, e.target.value) }}
                InputProps={{
                    emed_tid: `Field_${stateKey}`,
                    endAdornment: <Typography>{stateKey === "space_between_table" ? "cm" : ""}</Typography>,
                }}
            />
        )
    }

    const renderButton = (label, variant, onClick) => {
        return (<Button
            emed_tid={`lab_print_${label}`}
            disabled={state?.isLoader}
            variant={variant}
            size="small"
            id="eMed_Config_btn"
            sx={{ width: "10vw" }}
            onClick={() => { onClick() }} >
            {label}
        </Button>)
    }

    const renderRadioBtn = (label, value, checked, stateKey) => {
        return (
            <FormControlLabel control={
                <Radio size='small'
                    checked={checked}
                    value={value}
                    onChange={(e) => { handleBasicDataChange(stateKey, e.target.value) }}
                    inputProps={{ emed_tid: `lab_print_config_${stateKey}_radio` }}
                />}
                label={label} />
        )
    }

    const renderCheckbox = (label, stateKey, value, handleChange, isDisable = false) => {
        const changeHandler = handleChange || handleBasicDataChange;
        return (
            <FormControlLabel
                control={<Checkbox
                    disabled={isDisable}
                    checked={value}
                    onChange={(e) => { changeHandler(stateKey, e.target.checked) }}
                    inputProps={{ emed_tid: `lab_print_config_${stateKey}_checkbox` }}
                    size='small' />}
                label={<Typography fontSize={'0.9vw'} fontWeight={600}>
                    {label}
                </Typography>} />
        )
    }

    const renderHeadFooter = (text1, text2) => {
        return (
            <Box sx={{ width: "80%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
                <Typography fontSize={"0.8vw"} mb={"0.3vw"} flex={0.4} color={"#8a8585"}>{text1}</Typography>
                <Typography fontSize={"0.8vw"} mb={"0.3vw"} flex={0.6} color={"#8a8585"}>{text2}</Typography>
            </Box>
        )
    }

    const renderHeaderRow = (leftContent, rightContent) => {
        return (<Box sx={{ width: "80%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
            <Box sx={{ flex: 0.4 }}>{leftContent}</Box>
            <Box sx={{ flex: 0.6 }}>{rightContent}</Box>
        </Box>)
    }

    const renderBasicLayout = () => {
        return (
            <Box sx={{ width: "100%", height: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw", borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    {renderAutoComplete("Format", "format", state.basicData.format, formatList, "label", (key, value) => { handleBasicDataChange(key, value?.value) }, true, "15vw")}
                    {renderAutoComplete("Font", "font", state.basicData.font, fontList, "label", (key, value) => { handleBasicDataChange(key, value?.value) }, false, "15vw")}
                    {renderAutoComplete("Font Size", "fontSize", state.basicData.fontSize, fontSizeList, "", (key, value) => { handleBasicDataChange(key, value) }, false, "15vw")}
                </Box>
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Margin setup</Typography>
                    <Typography fontSize={"0.8vw"} mb={"0.3vw"} color={"#8a8585"}>Settings</Typography>
                    {renderTextField("Top", "Margintop", state.basicData.Margintop)}
                    {renderTextField("Bottom", "MarginBottom", state.basicData.MarginBottom)}
                    {renderTextField("Left", "MarginLeft", state.basicData.MarginLeft)}
                    {renderTextField("Right", "MarginRight", state.basicData.MarginRight)}
                </Box>
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Grid Setup</Typography>
                    <RadioGroup
                        value={state.basicData.gridSetup}
                        marginY={"0.5vw"} sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)" }}
                        onChange={(e) => { handleBasicDataChange("gridSetup", e.target.value) }}
                    >
                        {
                            gridSetupList?.map((item, index) => {
                                return (
                                    <FormControlLabel
                                        key={index}
                                        value={item.value}
                                        control={<Radio size='small' />}
                                        label={
                                            <span style={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
                                                {item.icon && <img src={item.icon} alt="" style={{ width: 20, height: 20 }} />}
                                                {item.label}
                                            </span>
                                        } />)
                            })
                        }
                    </RadioGroup>
                </Box>
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    <Typography fontSize={"0.8vw"} mb={"0.3vw"} color={"#8a8585"}>Stroke Weight</Typography>
                    {renderTextField("Grid Line", "gridLine", state.basicData.gridLine, true)}
                    {renderTextField("Separation Line", "separationLine", state.basicData.separationLine, true)}
                </Box>
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Header and Footer</Typography>
                    {/* Header */}
                    {renderHeadFooter("Header", "Spacing Height")}
                    {renderHeaderRow(
                        renderRadioBtn("With Out Header", "withoutHeader", state.basicData.withOutHeader, "withOutHeader"),
                        renderTextField("", "woHeadSpace", state.basicData.woHeadSpace))
                    }
                    {renderHeaderRow(
                        renderRadioBtn("With Header", "withHeader", state.basicData.withHeader, "withHeader"),
                        renderCheckbox("Print Header In All Pages", "printHeaderAllpages", state.basicData.printHeaderAllpages, state.basicData.withHeader === ""))
                    }
                    {/* Footer */}
                    {renderHeadFooter("Footer", "Spacing Height")}
                    {renderHeaderRow(
                        renderRadioBtn("With Out Footer", "withoutFooter", state.basicData.withOutFooter, "withOutFooter"),
                        renderTextField("", "woFootSpace", state.basicData.woFootSpace))
                    }
                    {renderHeaderRow(
                        renderRadioBtn("With Footer", "withFooter", state.basicData.withFooter, "withFooter"),
                        renderCheckbox("Print Footer In All Pages", "printFooterAllpages", state.basicData.printFooterAllpages, state.basicData.withFooter === "")
                    )}
                </Box>
            </Box>
        )
    }

    const renderAlignHeader = (thirdLabel = "Placement", fourthLabel = "") => {
        return (
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", marginY: "0.5vw", columnGap: "0.5vw" }}>
                {["System Name", "Custom Name", thirdLabel, fourthLabel]?.map((label, index) => (
                    <Typography
                        key={index}
                        fontSize="0.8vw"
                        mb="0.3vw"
                        color="#8a8585"
                    >
                        {label}
                    </Typography>
                ))}
            </Box>
        )
    }

    const renderAlignment = (label, stateKey, removeBorder = false) => {
        return (
            <Box marginY={"0.5vw"} sx={{ ...(removeBorder ? {} : { borderBottom: "1px solid lightGray" }) }}>
                <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{label}</Typography>
                {renderAlignHeader("Alignment", stateKey === "end_of_the_report" ? "Top Spacing" : "Width")}
                {state[stateKey]?.map((item, index) => {
                    const disableDiv = (item.field_name === "specimen_row" && state.content_test_report[1]?.is_active)
                        || (item.field_name === "specimen_column" && state.content_test_report[7]?.is_active);
                    return (
                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", marginY: "0.5vw", columnGap: "0.5vw" }} key={`${item.field_name}_${item.id}`}>
                            <FormControlLabel
                                control={<Checkbox
                                    id={item.id}
                                    checked={item.is_active}
                                    disabled={item?.field_name === "test_name" || disableDiv}
                                    onChange={(e) => { handleContentChange(stateKey, item.field_name, "is_active", e.target.checked) }} size='small' />}
                                label={<Typography fontSize={'0.9vw'} fontWeight={600}>
                                    {item.system_name}
                                </Typography>} />
                            {renderContentTextField(stateKey, item.field_name, "custom_name", index, disableDiv)}

                            {renderAutoComplete("", "alignment", item.alignment, alignmentList, "label",
                                (key, value) => { handleContentChange(stateKey, item.field_name, "alignment", value?.value) }, disableDiv)}

                            {(stateKey === "end_of_the_report" && item.field_name === "end_of_report") ?
                                renderContentTextField(stateKey, item.field_name, "space_between_table", index)
                                : keysHavingWidth.has(item.field_name) ? renderContentTextField(stateKey, item.field_name, "width", index, item.is_active === false)
                                    : null}
                        </Box>
                    )
                })}
            </Box>
        )
    }

    const renderSecHeader = (label = "") => {
        return (<Typography fontSize={'0.8vw'} color={"#8a8585"}>{label}</Typography>)
    }

    const handlePageEnd = (stateKey, updateKey, value) => {
        updateState({
            [stateKey]: {
                ...state[stateKey],
                [updateKey]: value
            }
        })
    }

    const renderPageEnd = (stateKey) => {
        const { is_active, left, center, right } = state[stateKey]
        return (
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", marginY: "0.5vw", columnGap: "0.5vw" }}>
                <FormControlLabel
                    control={<Checkbox
                        checked={is_active}
                        onChange={(e) => { handlePageEnd(stateKey, "is_active", e.target.checked) }} size='small' />}
                    label={<Typography fontSize={'0.9vw'} fontWeight={600} textTransform={"capitalize"}>
                        {stateKey}
                    </Typography>} />
                {renderTextField("", "left", left, false, (key, value) => { handlePageEnd(stateKey, key, value) })}
                {renderTextField("", "center", center, false, (key, value) => { handlePageEnd(stateKey, key, value) })}
                {renderTextField("", "right", right, false, (key, value) => { handlePageEnd(stateKey, key, value) })}

            </Box>)
    }

    const renderContentLayout = () => {
        return (
            <Box sx={{ width: "100%", height: "100%", padding: "0.625vw" }}>
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Patient Details</Typography>
                    {renderAlignHeader("Placement")}
                    {
                        state.content_patient?.map((item, index) => {
                            return (
                                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", marginY: "0.5vw", columnGap: "0.5vw" }} key={`${item.field_name}_${item.id}`}>
                                    <FormControlLabel
                                        control={<Checkbox
                                            disabled={item.field_name === "age_gender" && state.content_patient[0]?.is_separate_age === false}
                                            id={item.id}
                                            checked={item.is_active}
                                            onChange={(e) => { handleContentChange("content_patient", item.field_name, "is_active", e.target.checked) }} size='small' />}
                                        label={<Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                            {item.system_name}
                                        </Typography>} />
                                    {renderContentTextField("content_patient",
                                        item.field_name, "custom_name", index,
                                        (disableContentFields.has(item.field_name) || (item.field_name === "age_gender" && state.content_patient[0]?.is_separate_age === false)))}
                                    {renderAutoComplete("", "placement",
                                        item.placement, placementList, "label",
                                        (key, value) => { handleContentChange("content_patient", item.field_name, "placement", value?.value) },
                                        (item.field_name === "age_gender" && state.content_patient[0]?.is_separate_age === false))}
                                    {item.field_name === "name" && <FormControlLabel
                                        control={<Checkbox
                                            id={`${item.id}_Separate`}
                                            checked={item.is_separate_age}
                                            onChange={(e) => { handleContentChange("content_patient", item.field_name, "is_separate_age", e.target.checked) }} size='small' />}
                                        label={<Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Separate Age/Gender</Typography>} />}
                                </Box>
                            )
                        })
                    }
                </Box>
                {renderAlignment("Test Report", "content_test_report")}
                {renderAlignment("Page End", "end_of_the_report")}
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw" }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", columnGap: "0.5vw" }}>
                        {renderSecHeader()}
                        {renderSecHeader("Left")}
                        {renderSecHeader("Center")}
                        {renderSecHeader("Right")}
                    </Box>
                    {renderPageEnd("pathology")}
                    {renderPageEnd("microBiology")}
                </Box>

            </Box>
        )
    }

    const renderAdditionalLayout = () => {
        return (
            <Box sx={{
                width: "100%", height: "100%", padding: "0.625vw", display: "flex",
                flexDirection: "column",
                gap: "0.5vw",
            }}>
                {additionalConfigList?.map(({ label, key, key2, list }) => {
                    const disableDiv = (key === "view_specimen_row" && state.content_test_report[1]?.is_active)
                        || (key === "show_overall_sample_collected_date" && !state.content_test_report[6]?.is_active);
                    return (
                        <Box width={"100%"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            {renderCheckbox(label, key, state[key], (_, value) => updateState({ [key]: value }), disableDiv)}
                            {key2 && renderAutoComplete("", key2, state[key2], list, "label", (_, value) => updateState({ [key2]: value?.value }), disableDiv, "12vw")}
                        </Box>
                    )
                }
                )}
            </Box>
        )
    }

    const renderTabContent = (tabValue) => {
        switch (tabValue) {
            case 'basic':
                return renderBasicLayout();
            case 'content':
                return renderContentLayout();
            case 'additional':
                return renderAdditionalLayout();
            default:
                return null;
        }
    }

    return (
        <Box sx={{ height: "78.5vh" }}>
            <Box className='eMed_lab_printDiv'>
                <Paper elevation={2}>
                    <Typography className='eMed_refdoc_title'>{"Print Preview"}</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "72.5vh", overflowY: "auto" }}>
                        {state.previewLoader ?
                            <CircularProgress color="primary" size={"2vw"} />
                            : state.previewUrl ? <iframe
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                            src={`${state.previewUrl}#toolbar=1&navpanes=0`}
                            type="application/pdf" />
                            : <Typography fontSize={"1vw"}>No Records to be shown</Typography>}
                    </Box>
                </Paper>
                <Paper elevation={2}>
                    <Tabs
                        value={state.tabValue}
                        onChange={(e, newValue) => { updateState({ tabValue: newValue }) }}
                        sx={{ backgroundColor: Colors.DataTblHeaderbg, height: "6vh" }}
                    >
                        <Tab emed_tid='lab_print_config_basic_tab' value={'basic'} label='Basic Layout' className='eMed_tab_header' />
                        <Tab emed_tid='lab_print_config_content_tab' value={'content'} label='Content Setup' className='eMed_tab_header' />
                        <Tab emed_tid='lab_print_config_additional_tab' value={'additional'} label='Additional Configuration' className='eMed_tab_header' />
                    </Tabs>
                    <Box sx={{ height: "66.5vh", overflowY: "auto", padding: "0.5vw" }}>
                        {renderTabContent(state.tabValue)}
                    </Box>
                    <Box sx={{
                        width: "100%", display: "flex", justifyContent: "flex-end",
                        alignItems: "center", height: "6vh", gap: "0.5vw",
                        backgroundColor: Colors.DataTblHeaderbg, paddingRight: "0.625vw"
                    }}>
                        {renderButton("Reset", 'outlined', resetPrintDetails)}
                        {renderButton("Save", 'contained', validationData)}
                    </Box>
                </Paper>
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>
    )
}

export default withTranslation()(LabPrintConfiguration)